<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2 class="mb-0">{{userId ? 'Update' : 'Add New'}} User</h2>
</div>

<!--form section-->
<section [ngClass]="!loading ? 'block' : 'hidden'">
  <nz-card>
    <div class="grid lg:grid-cols-2">
      <div>
        <div class="flex flex-col min-[400px]:flex-row gap-3 min-[400px]:items-center">
          <!--      placeholder image-->
          <!--      data:image/png;base64,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-->
          <img *ngIf="uploadImageUrl" class="rounded-full w-[125px] h-[125px] sm:w-[150px] sm:h-[150px]"
               [src]="uploadImageUrl" alt=""/>
          <img *ngIf="!uploadImageUrl" class="rounded-full w-[125px] h-[125px] sm:w-[150px] sm:h-[150px]"
               src="assets/img/static/no-user.jpg" alt=""/>
          <div class="flex flex-col sm:flex-row gap-2">
            <nz-upload [nzCustomRequest]="customUploadReq"
                       [nzShowUploadList]="false"
                       [nzMultiple]="false">
              <button class="outline-button" nz-button>Upload Image</button>
            </nz-upload>
            <div><button *ngIf="uploadImageUrl" nz-button nzDanger nz-popconfirm
                         nzPopconfirmTitle="Are you sure you want to Remove this Image"
                         (nzOnConfirm)="removeProfileImg()">Remove</button></div>
          </div>
          <div>
            <p *ngIf="imageUploading" class="text-primary">Uploading...</p>
          </div>
        </div>
        <nz-divider></nz-divider>
        <div>
          <form nz-form [formGroup]="userForm" [nzLayout]="'vertical'">
            <div class="flex flex-col">
              <div class="grid sm:grid-cols-2 gap-2">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>First Name</nz-form-label>
                  <nz-form-control [nzErrorTip]="firstNameError">
                    <input nz-input type="text" formControlName="firstname" placeholder="Enter First Name"/>
                  </nz-form-control>
                  <ng-template #firstNameError>
                    <span *ngIf="formErrors.firstname.required">Please enter first name</span>
                    <span *ngIf="formErrors.firstname.pattern">Only allowed letters, please avoid adding special characters or numbers</span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Last Name</nz-form-label>
                  <nz-form-control [nzErrorTip]="lastNameError">
                    <input nz-input type="text" formControlName="lastname" placeholder="Enter Last Name"/>
                  </nz-form-control>
                  <ng-template #lastNameError>
                    <span *ngIf="formErrors.lastname.required">Please enter last name</span>
                    <span *ngIf="formErrors.lastname.pattern">Only allowed letters, please avoid adding special characters or numbers</span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Staff Number</nz-form-label>
                  <nz-form-control [nzErrorTip]="staffNumberErrors">
                    <input nz-input type="text" formControlName="staffNumber" placeholder="Enter Staff Number"/>
                  </nz-form-control>
                  <ng-template #staffNumberErrors>
                    <span *ngIf="formErrors.staffNumber.required">Please enter staff number</span>
                    <span *ngIf="formErrors.staffNumber.maxlength">Maximum 15 letters only</span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Email</nz-form-label>
                  <nz-form-control [nzErrorTip]="emailError">
                    <input nz-input type="text" formControlName="email" placeholder="Enter Email"/>
                  </nz-form-control>
                  <ng-template #emailError>
                    <span *ngIf="formErrors.email.required">Please enter email</span>
                    <span *ngIf="formErrors.email.email">Email is invalid</span>
                  </ng-template>
                </nz-form-item>
              </div>

              <div class="grid sm:grid-cols-2 gap-2">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired>Mobile Number</nz-form-label>
                  <nz-form-control [nzErrorTip]="mobileNumberError">
                    <input nz-input type="text" formControlName="mobile" placeholder="Enter Mobile Number"/>
                  </nz-form-control>
                  <ng-template #mobileNumberError>
                    <span *ngIf="formErrors.mobile.required">Please enter mobile number</span>
                    <span *ngIf="formErrors.mobile.pattern">Please enter valid mobile number</span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzRequired nzFor="role">Role</nz-form-label>
                  <nz-form-control [nzErrorTip]="roleCheck">
                    <nz-select formControlName="role" nzPlaceHolder="Select Role">
                      <nz-option *ngFor="let op of roleOptions" [nzValue]="op._id"
                                 [nzLabel]="wordCapitalize(op.name)"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #roleCheck></ng-template>
                </nz-form-item>
              </div>
              <div class="grid 2xl:grid-cols-2 gap-2">
                <nz-form-item class="grid grid-flow-row content-start md:col-span-2" style="margin-bottom:10px">
                  <nz-form-label nzRequired nzFor="department">Department</nz-form-label>
                  <nz-form-control [nzErrorTip]="departmentCheck">
                    <nz-select id="departSelect" [nzShowArrow]="true" [nzMode]="'multiple'" formControlName="department" nzPlaceHolder="Select Department">
                      <nz-option *ngFor="let op of depOptions" [nzValue]="op._id"
                                 [nzLabel]="op.company ? op.department.name + ' - ' + op.company.name : op.department.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #departmentCheck></ng-template>
                </nz-form-item>
                <div class="md:col-span-2 mb-2">
                  <nz-alert nzType="info" nzMessage="To add multiple departments, You can select multiple options here!" class="mb-3" nzShowIcon></nz-alert>
                </div>
              </div>

              <div>
                <h6>User Status</h6>
                <div class="flex justify-between items-center gap-2">
                  <p>{{statusValue ? 'Active' : 'Not Active'}} means user {{statusValue ? 'will' : 'will not'}} be able to
                    access the system</p>
                  <nz-switch formControlName="active" [(ngModel)]="statusValue" [nzLoading]="statusLoading"></nz-switch>
                </div>
              </div>

            </div>
          </form>
        </div>

        <nz-divider></nz-divider>

        <div class="flex justify-end">
          <button [disabled]="userForm.invalid" nz-button nzType="primary"
                  (click)="submit()">Update User</button>
        </div>
        <nz-alert
          *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type" [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>
      </div>
    </div>
  </nz-card>
</section>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>


